export { default } from './cannabinoid-grid';
